export default __webpack_public_path__ + "static/media/12.9b05896f.jpg";